// Figma: "Invoices / All Communities / Expanded" and siblings (node 18698:9037, Invoice
// canvas — see the frame list under that node for every state this page covers).
//
// The Figma table groups invoices by community, then by month, filtered by a single Year
// picker — but the existing (already-ported, see Crm/Invoice.js) `getPastInvoicesList`
// endpoint returns the opposite shape: `[{year, months: [{month, files: [{community_name,
// path}]}]}]`, i.e. year → month → communities. These helpers invert that into
// community → months for whichever year is selected, and fold `getCurrentInvoicesList`
// (which has no month of its own — it's simply "this account's latest invoice batch") in
// as the current calendar month's entry, same as a month the past-invoices endpoint would
// have returned once it rolls over.
const MONTH_ORDER = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const monthIndex = (month) => MONTH_ORDER.indexOf(month);

// Every year the past-invoices endpoint knows about, plus the current year (so the Year
// dropdown always has somewhere for a brand-new account's first/current invoice to show up
// even before any past invoice exists), newest first — matches the Figma Year Dropdown's
// 2026 → 2018 ordering.
export const getAvailableYears = (pastInvoices) => {
    const years = new Set((pastInvoices || []).map((entry) => Number(entry.year)).filter((year) => !Number.isNaN(year)));
    years.add(new Date().getFullYear());
    return Array.from(years).sort((a, b) => b - a);
};

// Map<communityName, Array<{month, path}>> for the selected year, sorted newest-month-first
// (August, July, June, … to match the Figma row order).
export const buildCommunityGroups = ({pastInvoices, currentInvoices, selectedYear}) => {
    const groups = new Map();
    const addFile = (communityName, month, path) => {
        if (!communityName || !path) return;
        if (!groups.has(communityName)) groups.set(communityName, []);
        const months = groups.get(communityName);
        if (!months.some((entry) => entry.path === path)) months.push({month, path});
    };

    const yearEntry = (pastInvoices || []).find((entry) => String(entry.year) === String(selectedYear));
    (yearEntry?.months || []).forEach(({month, files}) => {
        (files || []).forEach(({community_name, path}) => addFile(community_name, month, path));
    });

    if (String(selectedYear) === String(new Date().getFullYear())) {
        const currentMonthLabel = MONTH_ORDER[new Date().getMonth()];
        (currentInvoices || []).forEach(({community_name, path}) => addFile(community_name, currentMonthLabel, path));
    }

    groups.forEach((months) => months.sort((a, b) => monthIndex(b.month) - monthIndex(a.month)));

    return groups;
};
